import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Credits = Class.create({
  	initialize: function() {
  		this.server = server;
	},
	getCredits: function(callback) {
		var self = this;
		var url = "credits"; //TODO: Change this to correct URL
		var data = self.server.getData(url, null, true);
		data
		.done(function(response){
			if (response.data.error_user_authentication == 1)
			{
			}
			else if (response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			}
            if (callback) {
                callback(response);
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like something went wrong!", "danger", "top", "center");
		});
    },
});

export let credits = new Credits();


// WEBPACK FOOTER //
// app/core/controllers/Credits.js